// MD2 PRO
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Card from '@mui/material/Card';

// Components
import TaskListModalView from 'components/General/Task/Views/TaskList/ModalView';

function ProductionTasks({ production }) {
    return (
        <MDBox>
            {production?.taskList ? (
                <MDBox>
                    <TaskListModalView taskListID={production?.taskList} taskID={null} id="tasks" />
                </MDBox>
            ) : (
                <Card>
                    <MDBox p={3}>
                        <MDTypography variant="body1" color="text">
                            Bu üretim için henüz görev listesi oluşturulmamış.
                        </MDTypography>
                    </MDBox>
                </Card>
            )}
        </MDBox>
    );
}

export default ProductionTasks;
